<template>
  <v-menu bottom left offset-y>
    <template #activator="{on,attrs}">
      <v-btn class="white--text" v-bind="attrs" v-on="on" text>
        {{ user.display_name }}
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <template>
      <v-card>
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ user.display_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list class="pa-0">
            <v-list-item
              v-for="item in list[locale]"
              :key="item.uid"
              :to="item.to"
            >
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
            <v-list-item v-if="admin" key="item.uid" :to="adminBtn[locale].to">
              <v-list-item-icon>
                <v-icon v-text="adminBtn[locale].icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                v-text="adminBtn[locale].text"
              ></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="signout" color="primary" text>{{
            logout[locale].text
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-menu>
</template>

<script>
// import { auth } from "@/common/firebase.js";
export default {
  name: "UserMenu",
  props: {
    user: {
      type: Object,
      required: true
    },
    locale: {
      type: String
    }
  },
  data() {
    return {
      admin: false,
      list: {
        sv: [
          {
            uid: "fdakdjf",
            text: "Hem",
            to: "/",
            icon: "mdi-home"
          },
          // {
          //   uid: "dsfadsf",
          //   text: "Min sida",
          //   to: "/profile",
          //   icon: "mdi-account"
          // }
        ],
        en: [
          {
            uid: "fadsmf.",
            text: "Home",
            to: "/",
            icon: "mdi-home"
          },
          /*{
            uid: "xcz,m.n",
            text: "My account",
            to: "/profile",
            icon: "mdi-account"
          }*/
        ],
        ar: [
          {
            uid: "ffdsadsmf.",
            text: "Home",
            to: "/",
            icon: "mdi-home"
          },
          /*{
            uid: "xcz,dam.n",
            text: "My account",
            to: "/profile",
            icon: "mdi-account"
          }*/
        ]
      },
      adminBtn: {
        sv: {
          uid: "fdsjölk",
          text: "Administratör",
          to: "/admin",
          icon: "mdi-shield-account"
        },
        en: {
          uid: "ödfsjkla",
          text: "Administrator",
          to: "/admin",
          icon: "mdi-shield-account"
        },
        ar: {
          uid: "ödfsjkla",
          text: "Administrator",
          to: "/admin",
          icon: "mdi-shield-account"
        }
      },
      logout: {
        sv: { uid: "sdafmlk", text: "Logga ut" },
        en: { uid: "asfklöj", text: "Sign out" },
        ar: { uid: "asfklöjfew", text: "Sign out" }
      }
    };
  },
  methods: {
    isAdmin() {
      return this.$store.getters["user/IS_ADMIN"];
    },
    signout() {
      this.$store.dispatch("user/LOGOUT");
      this.$router.push("/login");
    }
  },
  mounted() {
    this.admin = this.isAdmin();
  }
};
</script>

<style lang="scss" scoped></style>
